import { appNav } from './app-nav/app-nav.module';
import { headerMenus } from './header-menus/header-menus.module';
import { appComponent } from './app.component.js';
import { components } from './components/components.module';
import { libs } from './libs/libs.module';

export const app = angular
	.module('common.appNav', [
		appNav,
		headerMenus,
		components,
		libs
	])
	.component('app', appComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/app.module.js